import React, { cloneElement, ForwardedRef, forwardRef, ReactElement } from 'react';
import times from 'lodash/times';
import { Flex, FlexProps } from './Flex';

interface ListViewProps extends FlexProps {
    count: number;
    renderItem: (index: number) => ReactElement;
}

export const Stack = forwardRef(
    (props: ListViewProps, ref: ForwardedRef<HTMLDivElement | null>) => {
        const { count, renderItem, ...other } = props;

        return (
            <Flex ref={ref} role="list" {...other}>
                {times(count, (idx) => cloneElement(renderItem(idx), { role: 'listitem' }))}
            </Flex>
        );
    },
);
